import { Range } from '../types/profile';

export const US_LATITUDE_RANGES: Range[] = [
  { min: 18.910161, max: 71.5388 }, // Continental US, Alaska, Hawaii
  { min: 17.83, max: 18.52 }, // Puerto Rico
  { min: 13.24, max: 13.65 }, // Guam
  { min: -14.4, max: -11.05 }, // American Samoa
  { min: 14.1, max: 20.55 }, // Northern Mariana Islands
  { min: 17.68, max: 18.42 }, // U.S. Virgin Islands
];

export const US_LONGITUDE_RANGES: Range[] = [
  { min: -179.148909, max: -66.93457 }, // Continental US, Alaska, Hawaii
  { min: -67.24, max: -65.22 }, // Puerto Rico
  { min: 144.6, max: 144.96 }, // Guam
  { min: -171.09, max: -168.14 }, // American Samoa
  { min: 144.9, max: 146.06 }, // Northern Mariana Islands
  { min: -65.08, max: -64.28 }, // U.S. Virgin Islands
];

export const ROLE = {
  FULL_ACCESS: 'Full Access',
  MANAGER: 'Manager',
  PENDING: 'Pending',
  SALESPERSON: 'Salesperson',
  USER: 'User',
  OPERATIONS: 'Operations',
  DRIVER: 'Driver',
  PENDING_USER_SUFFIX: ' (pending)',
};
